import { styleSizesNumber } from 'constants/styleSizes';
import { FC, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import FormInputField from 'components/FormInputField'
import { useAuth } from 'customHooks/useAuth'
import { SetPasswordScreenContainer } from './style';
import StyledButton from 'components/Button';
import { useMutation } from '@apollo/client';
import { SETUP_USER_PASSWORD_NEW } from 'graphql/service';
import PasswordStrengthBar from 'components/PasswordStrengthBar';
import { colors } from 'constants/colors'
import { PasswordToolTip } from 'assets/icons'
import setPasswordImage from 'assets/icons/setPassword.jpg';
import { useGlobalAlerts } from 'customHooks/useGlobalAlerts';

const SetPasswordForm: FC = () => {


  const debug = false;

  const history = useHistory()
  const { userSignIn } = useAuth()
  const location = useLocation()
  const params = new URLSearchParams(location.search)
  //const email = params.get('email') ?? "";
  const oneTimeToken = params.get('oneTimeToken') ?? "";

  const { showGlobalError } = useGlobalAlerts();

  useEffect(() => {
    if (!oneTimeToken) {
      history.push('/')
    }
  }, [oneTimeToken, history])





  const [password, setPassword] = useState('')
  const [isHovered, setIsHovered] = useState(false)


  const [setupUserPassword] = useMutation(
    SETUP_USER_PASSWORD_NEW,
    {
      onCompleted: (setupUserPasswordData)=> {
        if(setupUserPasswordData.setupUserPassword?.auth.accessToken) {
          // const token = setupUserPasswordData.setupUserPassword?.auth.accessToken;        
          // const decoded: JsonWebToken = jwt_decode(token)
          // localStorage.setItem('userId', decoded.sub)
          // localStorage.setItem('token', token)
          if (debug) {
            console.log ('setupUserPasswordData:', setupUserPasswordData);
          }
          // Uncomment it once @Emmy done RHCFW-413 to finish RHCFW-400, RHCFW-182, RHCFW-404
          // 
          
          userSignIn(setupUserPasswordData.setupUserPassword?.user.email, password, '/setup-complete');
          
          //userSignIn(email, password, '/account/dashboard');
          //history.push('/account/dashboard')
        }  else {
          const content = 'Setup failed. Please try again later or contact our support.'
          showGlobalError(content);
          console.log(content)
        }
      },
      onError: (error)=> {
        const content = error.message
        console.log(content)
        showGlobalError(content);
      }
    }
  )

  // const handleSubmit = () => {
  //   if(validToken) {
  //     setupUserPassword({
  //       variables: {
  //         input: {
  //           oneTimeToken,
  //           newPassword: password,
  //         }
  //       }
  //     })
  //   } else {
  //     console.log('Session expired, please try again!')
  //     history.push('/signIn')
  //   }
  // }

const handleSubmit = () => {
  
  if(oneTimeToken) {
      localStorage.setItem('token', oneTimeToken);
  }


    if (debug) {
      console.log ('oneTimeToken:', oneTimeToken);
      console.log ('password:', password);
    }
    
      setupUserPassword({
        variables: {
          input: {
            oneTimeToken: oneTimeToken,
            newPassword: password
          }
        }
      })
  }



  return (
    <SetPasswordScreenContainer>
      <div className="titleContainer">
        <div className="innerContainer ">
          <div className='titleText'>
            <div className="title">
              <div className="titleFirst">Select <span className='highLight'>a secret password</span></div>
              <div className="titleSecond">to finish setting up your account.</div>
            </div>
          </div>
          <img src={setPasswordImage} alt="Set password" className="setPasswordImage" />
        </div>
      </div>
      <div className="inputRow">
        <div className="innerContainerSetPassword">
          <div className="description">
            You’ll use this password to access your Rook account, manage your bookings, and even make special requests during your hotel stay. Please choose a password that is <span className='highLight'>at least 8 characters long</span>.
          </div>
          <div className="passwordInputBox">
            <FormInputField
              label={'PASSWORD'}
              labelColor={colors.noBookingText}
              labelSize={'14px'}
              labelWeight={'400'}
              isRequired
              inputTextColor={colors.black}
              inputFontSize={'16px'}
              inputFontWeight={'600'}
              inputHeight={'48px'}
              inputBackgroundColor={'transparent'}
              //width={'70%'}
              marginBottom='8px'
              borderColor={colors.signInBorderColor}
              autoComplete="new-password"
              type="password"
              onChange={(e) => {
                setPassword(e.target.value)
              }}
              value={password}
            />
            <PasswordStrengthBar
              className="passwordStrengthBar"
              password={password}
            />
          </div>
          <div
            className='buttonContainer'
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            <StyledButton
              width="114px"
              height="48px"
              disabled={password.length < 8}
              margin={'10px 0 0 0'}
              onClick={handleSubmit}
            >
              Submit
            </StyledButton>
            {isHovered && password.length < 8 && window.innerWidth > styleSizesNumber.mobileBreakpoint ? (
              <PasswordToolTip />
            ) : null}
          </div>
        </div>
      </div>
    </SetPasswordScreenContainer>
  )
}

export default SetPasswordForm;